import React from 'react'
import { C_BlogsData } from '../../constants'
import { useStateContext } from '../../context/ContextProvider'
import { C_BlogCard } from './layout'
const C_Blogs = () => {
    const {currentLang}=useStateContext()
    const isAr =currentLang ==="ar"
  return (
    <div className='relative mt-12 md:mt-16 lg:mt-20'>
        <section className='container '>
            <div className=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 ">
            {
    C_BlogsData.map((card)=>(
        <C_BlogCard 
          card={card}
        />
    ))
}
            </div>

        </section>
    </div>
  )
}

export default C_Blogs